import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";
import { Logo } from "./Logo";
import { COMPANY } from "../data/site";

const COLS = [
    {
        title: "COMPANY",
        links: [
            { label: "About", to: "/about" },
            { label: "Quality", to: "/quality" },
            { label: "Projects", to: "/projects" },
            { label: "Contact", to: "/contact" },
        ],
    },
    {
        title: "SOLUTIONS",
        links: [
            { label: "Industrial Furnaces", to: "/products/electric-industrial-furnaces" },
            { label: "Process Systems", to: "/products/process-heating-systems" },
            { label: "Automation", to: "/products/plc-hmi-automation-systems" },
            { label: "Electrical Systems", to: "/products/electrical-power-control-systems" },
        ],
    },
    {
        title: "SERVICES",
        links: [
            { label: "Engineering", to: "/services" },
            { label: "Manufacturing", to: "/services" },
            { label: "Installation", to: "/services" },
            { label: "Commissioning", to: "/services" },
            { label: "Service", to: "/services" },
        ],
    },
];

export const Footer = () => (
    <footer className="bg-brand-ink text-slate-300 technical-grid" data-testid="site-footer">
        <div className="mx-auto max-w-[1440px] px-4 sm:px-6 lg:px-10 py-16 md:py-20">
            <div className="grid gap-12 lg:grid-cols-12">
                <div className="lg:col-span-4">
                    <Logo dark />
                    <p className="mt-6 font-mono text-[11px] tracking-[0.24em] text-brand-ember uppercase">
                        {COMPANY.tagline}
                    </p>
                    <p className="mt-5 max-w-sm text-sm leading-relaxed text-slate-400">
                        Industrial furnace solutions engineered for reliable heating, precise temperature control and demanding industrial processes.
                    </p>
                    <p className="mt-6 font-mono text-[10px] tracking-[0.18em] text-slate-500 uppercase">
                        GSTIN: {COMPANY.gstin}
                    </p>
                </div>
                {COLS.map((col) => (
                    <div key={col.title} className="lg:col-span-2">
                        <p className="font-display text-xs font-bold tracking-[0.22em] text-white">{col.title}</p>
                        <ul className="mt-5 space-y-3">
                            {col.links.map((l) => (
                                <li key={l.label}>
                                    <Link to={l.to} data-testid={`footer-${col.title.toLowerCase()}-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                                        className="text-sm text-slate-400 transition-colors hover:text-brand-ember">
                                        {l.label}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </div>
                ))}
                <div className="lg:col-span-2">
                    <p className="font-display text-xs font-bold tracking-[0.22em] text-white">CONTACT</p>
                    <ul className="mt-5 space-y-4 text-sm text-slate-400">
                        <li className="flex gap-2.5">
                            <MapPin size={15} className="mt-0.5 shrink-0 text-brand-red" />
                            <span>Greater Noida, Uttar Pradesh, India</span>
                        </li>
                        <li>
                            <a href={`tel:${COMPANY.phone1.replace(/\s/g, "")}`} data-testid="footer-phone-1" className="flex gap-2.5 transition-colors hover:text-brand-ember">
                                <Phone size={15} className="mt-0.5 shrink-0 text-brand-red" /> {COMPANY.phone1}
                            </a>
                        </li>
                        <li>
                            <a href={`tel:${COMPANY.phone2.replace(/\s/g, "")}`} data-testid="footer-phone-2" className="flex gap-2.5 transition-colors hover:text-brand-ember">
                                <Phone size={15} className="mt-0.5 shrink-0 text-brand-red" /> {COMPANY.phone2}
                            </a>
                        </li>
                        <li>
                            <a href={`mailto:${COMPANY.email}`} data-testid="footer-email" className="flex gap-2.5 break-all transition-colors hover:text-brand-ember">
                                <Mail size={15} className="mt-0.5 shrink-0 text-brand-red" /> {COMPANY.email}
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
            <div className="mt-14 flex flex-col items-start justify-between gap-4 border-t border-brand-line pt-7 sm:flex-row sm:items-center">
                <p className="font-mono text-[11px] tracking-[0.14em] text-slate-500">
                    © 2026 SS ENGINEERING WORKS. ALL RIGHTS RESERVED.
                </p>
                <p className="font-mono text-[11px] tracking-[0.14em] text-slate-500">
                    {COMPANY.secondary}
                </p>
            </div>
        </div>
    </footer>
);
